import { IconProps } from "../../utils/global-types/global-types";

const CallInitiatedIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 19"
      className={className ? className : "w-[18px] h-[19px]"}
      {...rest}
    >
      <path
        stroke="currentColor"
        strokeMiterlimit="10"
        strokeWidth="1.125"
        d="M16.478 14.708c0 .27-.06.547-.188.817-.127.27-.292.525-.51.765a3.4 3.4 0 0 1-1.23.885q-.674.284-1.463.285c-.764 0-1.582-.18-2.444-.547a13.2 13.2 0 0 1-2.58-1.485 21.6 21.6 0 0 1-2.46-2.1 21 21 0 0 1-2.093-2.453c-.615-.855-1.11-1.71-1.47-2.558Q1.5 7.035 1.5 5.865c0-.51.09-.998.27-1.448q.268-.687.862-1.252c.48-.473 1.006-.705 1.56-.705.21 0 .42.045.608.135.195.09.368.225.503.42l1.74 2.452c.135.188.232.36.3.525.067.158.104.315.104.458 0 .18-.052.36-.157.532q-.149.261-.42.533l-.57.592a.4.4 0 0 0-.12.3c0 .06.008.113.022.173.023.06.045.105.06.15.136.247.368.57.698.96.338.39.697.787 1.087 1.185.406.398.795.765 1.193 1.102.39.33.713.556.967.69.038.015.083.038.135.06.06.023.12.03.188.03a.41.41 0 0 0 .308-.127l.57-.562q.28-.284.54-.42a1 1 0 0 1 .532-.158q.213-.002.457.098a3 3 0 0 1 .526.292l2.482 1.762c.195.136.33.293.413.48.075.188.12.376.12.585Z"
      ></path>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.125"
        d="M15 3.96h-3.6m3.6 0v3.6z"
      ></path>
    </svg>
  );
};

export default CallInitiatedIcon;
